import React from "react";
import { MFE_Editor_Message } from "../../../../../Utils/config/config";

const RemoteFallback = () => {
  const { ERROR = "Failed to load remote component", MESSAGE = "Please try again later." } = MFE_Editor_Message || {};

  return (
    <div style={{
      padding: '40px',
      color: 'red',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px'
    }}>
      {ERROR}. {MESSAGE}
    </div>
  );
};

export default RemoteFallback;
